import {Page} from "@/PageDescriptors";
import {AllocationPageType, DomainAllocationSettings} from "./DomainAllocationSettings";
import {DomainAllocationServices} from "./DomainAllocationServices";
import {defineMessage, MessageDescriptor} from "react-intl";
import {labelForCapabilitySet, labelForDeviceTypeSet, labelForUserPackage} from "@/utils/translations";

const ALLOCATION_PAGES_PROPS: {
    path: string;
    label: MessageDescriptor;
    allocationType: AllocationPageType;
    labelForAllocation: (allocationName: string) => MessageDescriptor;
}[] = [
    {
        path: "user-package",
        label: defineMessage({id: "user_package", defaultMessage: "User package"}),
        allocationType: "userPackages",
        labelForAllocation: labelForUserPackage,
    },
    {
        path: "device-type-sets",
        label: defineMessage({id: "device_type_sets", defaultMessage: "Device type sets"}),
        allocationType: "deviceTypeSets",
        labelForAllocation: labelForDeviceTypeSet,
    },
    {
        path: "capability-sets",
        label: defineMessage({id: "capability_sets", defaultMessage: "Capability sets"}),
        allocationType: "capabilitySets",
        labelForAllocation: labelForCapabilitySet,
    },
];

export default function createAllocationPages(): Page[] {
    /**
     * Function to create the allocation pages for the domain settings.
     * Types are defined in the ALLOCATION_PAGES_PROPS array.
     */
    const pages: Page[] = [];

    pages.push(
        ...ALLOCATION_PAGES_PROPS.map((page) => {
            return {
                path: page.path,
                label: page.label,
                contentComponent: (props: {[s: string]: any}) => (
                    <DomainAllocationSettings
                        domainId={props.domainId}
                        allocationType={page.allocationType}
                        labelForAllocation={page.labelForAllocation}
                        label={page.label}
                    />
                ),
            } as Page;
        }),
    );

    pages.push({
        path: "services",
        label: defineMessage({id: "services", defaultMessage: "Services"}),
        contentComponent: (props: {[s: string]: any}) => <DomainAllocationServices domainId={props.domainId} />,
    });

    return pages;
}
